import Vue from "vue";
import Router from "vue-router";
// import { DATA } from "../../filter/filter";
import clientRouter from "./views/client/client.router";
import opeRouter from "./views/ope/ope.router";
Vue.use(Router);
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
const router = new Router({
  mode: "hash",
  baseUrl: process.env.base,
  routes: [
    {
      path: "/",
      component: () => import("./views/ope/ope.vue"),
      children: opeRouter
    },
    {
      path: "/client",
      component: () => import("./views/client/client.vue"),
      children: clientRouter
    },
    {
      path: "/notfound",
      component: () => import("./views/404/404.vue"),
      meta: { title: "404" }
    },
    {
      path: "*",
      component: () => import("./views/404/404.vue"),
      meta: { title: "404" }
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (process.env.VUE_APP_HOME_LOGIN === "false" && to.meta.HOME_LOGIN) {
    next({
      path: "/"
    });
    return;
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  console.log(
    window.navigator.userAgent !== "Ios_WebView2020_kredi360",
    window.navigator.userAgent
  );
  if (
    to.meta.onlyApp === true &&
    window.navigator.userAgent !== "Android_WebView2020_kredi360" &&
    window.navigator.userAgent !== "Ios_WebView2020_kredi360"
  ) {
    console.log("only client");
    next({
      path: "/notfound"
    });
  }

  next();
});
router.afterEach((to, from) => {
  if (to.name !== from.name) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }
});
export default router;
